export enum NotificationOperation {
    None = 0,
    Add = 1,
    Update = 2,
    Delete = 3,
    Completed = 4
}